export default __webpack_public_path__ + "static/media/p17.8fdbbdcd.jpg";